import idConfig from 'utils/ecommerce/services/id.config';
import { getLanguage } from 'utils/language/language';
import { env as E } from 'config/app.config';

export const addToCart = () => {
	const language = (idConfig.LANGUAGE as any)[getLanguage().toUpperCase()];
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	return {
		method: 'POST',
		url: `/wcs/resources/store/${storeId}/cart?langId=${language}`,
	};
};

export const validateCart = (): any => {
	const language = (idConfig.LANGUAGE as any)[getLanguage().toUpperCase()];
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	return {
		method: 'POST',
		url: `/wcs/resources/store/${storeId}/ebu/tariffValidate?langId=${language}`,
	};
};

export const clearAllCartItems = (): any => {
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	return {
		method: 'DELETE',
		url: `/wcs/resources/store/${storeId}/cart/@self`,
	};
};

export const removeSingleCartItem = (): any => {
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	return {
		method: 'PUT',
		url: `/wcs/resources/store/${storeId}/cart/@self/delete_order_item`,
	};
};

export const viewCart = (): any => {
	const language = (idConfig.LANGUAGE as any)[getLanguage().toUpperCase()];
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	return {
		method: 'GET',
		url: `/wcs/resources/store/${storeId}/cart/@self?currency=OMR&sortOrderItemBy=orderItemID&langId=${language}`,
	};
};
